import createIcon from '../../createIcon';

/**
 * @component @name Tune
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxN1YxOUg5VjE3SDNaTTMgNVY3SDEzVjVIM1pNMTMgMjFWMTlIMjFWMTdIMTNWMTVIMTFWMjFIMTNaTTcgOVYxMUgzVjEzSDdWMTVIOVY5SDdaTTIxIDEzVjExSDExVjEzSDIxWk0xNSA5SDE3VjdIMjFWNUgxN1YzSDE1VjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tune = createIcon('Tune', [
  [
    'path',
    {
      d: 'M3 17V19H9V17H3ZM3 5V7H13V5H3ZM13 21V19H21V17H13V15H11V21H13ZM7 9V11H3V13H7V15H9V9H7ZM21 13V11H11V13H21ZM15 9H17V7H21V5H17V3H15V9Z',
      key: '14ft49',
    },
  ],
]);

export default Tune;
